import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/admin/AAgent/index", {
        params: {
            ...params
        }
    } )
}
function EDIT_DATA(params) {
    return  axios.post("/admin/AAgent/edit",
        {id:params}
    )
}
function SUBMIT_ADD(params) {
    return  axios.post("/admin/AAgent/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/admin/AAgent/editPost",{...params} )
}


function DELE(params) {
    return  axios.get("/admin/AAgent/delete",{
        params: {
            id:params
        }
    } )
}
export default {
    GET_LIST,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    DELE,
}
